import { Injectable } from "@angular/core";
// import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class DoorsService {
  constructor(private httpClient: HttpClient) {}

  getUserAptList(): Observable<any> {
    const api =
      "https://nrmapi.azurewebsites.net/api/getuserdoor?aptid=49960515-8D1F-422B-B042-18C5E8D0D1C5";
    return this.httpClient.get(api);
  }

  updateUser(userData): Observable<any> {
    console.log("in put req - update: ", userData);
    const api = "https://nrmapi.azurewebsites.net/api/UpdateDoor";
    return this.httpClient.post(api, userData);
  }
}
